









import {
  News,
  Partners,
  Contacts,
  SiteNavigationList,
  PhotoGallery,
  Statistics,
  Logos,
  UserPanel,
  Events,
  NavSidebar,
  QuickFilter,
  NavHeader,
  SignboardNew
} from '../sections';
import { LayoutDataSet } from '@/uikit/components/AppDefaultLayout/types/LayoutTypes';

export default {
  props: {
    sectionName: {
      type: String,
    },
    config: {
      type: Object,
    },
    dataSet: {
      type: Object as () => LayoutDataSet,
    },
  },
  data() {
    return {
      blockTypes: {
        news: News,
        events: Events,
        partners: Partners,
        contacts: Contacts,
        signboard: SignboardNew,
        siteNavigationList: SiteNavigationList,
        photoGallery: PhotoGallery,
        statistics: Statistics,
        logos: Logos,
        userPanel: UserPanel,
        navSidebar: NavSidebar,
        quickFilter: QuickFilter,
        navHeader: NavHeader,
      },
    };
  },
  components: {
    ...this.blockTypes,
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/uikit/components/AppDefaultLayout/components/sections/PageSection.vue